import React, { useEffect } from 'react';
import { UnfoldProvider, useAppState } from '@unfold/provider';
import { api } from '@unfold/api';
import { Main } from './main';

export const App: React.FC = () => {
  const [state, actions] = useAppState();
  useEffect(() => {
    const interceptorId = api.interceptors.response.use(
      (response) => response,
      (err) => {
        if (
          localStorage.getItem('token') &&
          (err.response.status === 401 ||
          err.response.status === 403)
        ) {
          actions.removeToken();
          actions.setAuthError(err.response.data.error);
        }

        return Promise.reject(err);
      }
    );

    return (): void => {
      api.interceptors.response.eject(interceptorId);
    };
  }, []);

  return (
    <UnfoldProvider theme={state.theme}>
      <Main />
    </UnfoldProvider>
  );
};
